import { createContext } from "react";

const GlobalContext = createContext(null)

export { GlobalContext }